import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { AuthAccountUserState } from './auth-account-user.state';
import { AuthAccountUserStore } from './auth-account-user.store';

@Injectable({providedIn: 'root'})
export class AuthAccountUserQuery extends QueryEntity<AuthAccountUserState> {
  constructor(protected readonly store: AuthAccountUserStore) {
    super(store);
  }
}
